import { sbEditable } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { ButtonModule } from "../Button";
import styled from 'styled-components'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { containerDefault } from '../../lib/styles/Container'
import { Columns } from './Columns'
import { Slider } from './Slider'
import { TeaserCardGridProps } from './types'

const ModuleWrapper = styled.div`
  margin-block: 6rem;
`

const ModuleContainer = styled.div<{
  $align?: 'left' | 'center'
  $mediumCenterMargin: string
  $smallCenterMargin: string
  $mediumLeftMargin: string
  $smallLeftMargin: string
}>`
  ${containerDefault}
  margin-inline: auto;
  margin-bottom: ${p => p.$mediumCenterMargin || p.$smallCenterMargin || p.$mediumLeftMargin || p.$smallLeftMargin};
  text-align: ${p => p.$align || 'left'};
`

const ButtonContainer = styled.div`
  ${containerDefault}
  margin-inline: auto;
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  align-content: center;
`;

export const TeaserCardStepsGrid = ({ blok }: TeaserCardGridProps) => {
  const { isSlider, buttons, noBorder } = blok

  const headlineSize = blok.headlineSize ? blok.headlineSize : 'small'
  const blokAlignment = blok.alignment ? blok.alignment : 'left'

  const mediumCenterMargin = headlineSize === 'medium' && blokAlignment === 'center' ? '3rem' : ''
  const smallCenterMargin = headlineSize === 'small' && blokAlignment === 'center' ? '2.5rem' : ''
  const mediumLeftMargin = headlineSize === 'medium' && blokAlignment === 'left' ? '1.5rem' : ''
  const smallLeftMargin = headlineSize === 'small' && blokAlignment === 'left' ? '1rem' : ''

  return (
    <ModuleWrapper {...sbEditable(blok)}>
      {!!blok.title && !isSlider && (
        <ModuleContainer
          $mediumCenterMargin={mediumCenterMargin}
          $smallCenterMargin={smallCenterMargin}
          $mediumLeftMargin={mediumLeftMargin}
          $smallLeftMargin={smallLeftMargin}
          $align={blok.alignment}
        >
          <TitleWithPrefix
            title={blok.title}
            headlineSize={blok.headlineSize}
            textAlign={blok.alignment}
            headlineType={blok.headlineSyntax}
          />
        </ModuleContainer>
      )}
      {!isSlider && <Columns blok={blok} $align={blok.alignment} $width={blok.width} />}
      {isSlider && (
        <Slider
          mediumCenterMargin={mediumCenterMargin}
          smallCenterMargin={smallCenterMargin}
          mediumLeftMargin={mediumLeftMargin}
          smallLeftMargin={smallLeftMargin}
          showOnDesktop={isSlider}
          blok={blok}
        />
      )}
      {buttons && (
        <ButtonContainer>
          {buttons.map((button) => (
            <ButtonModule key={button._uid} blok={button} />
          ))}
        </ButtonContainer>
      )}
    </ModuleWrapper>
  )
}
